var isGTMHidden = document.querySelector('meta[name="hideGTM"]')?.content;

if (isGTMHidden === "false") {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "page_viewed",
      page_title: "Rental tracker",
      page_location: window.location.pathname,
    });
  }

  var rental_prefetch_list = [];
  var rentalLinks = document.querySelectorAll(".rental-tracker__item");
  rentalLinks?.forEach((link) => {
    rental_prefetch_list.push(link.href)
    link?.addEventListener("click", function (e) {
      var linkName = e.target
        .closest(".rental-tracker__item")
        .querySelector(".rental-tracker__item-title").innerText;
      var linkDestination = new URL(
        e.target.closest(".rental-tracker__item").href
      ).pathname;

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "cta_clicked",
          link_name: linkName,
          link_type: "anchor",
          link_location: "body",
          link_destination: linkDestination,
        });
      }
    });
  });

  try {
      if (
          HTMLScriptElement.supports &&
          HTMLScriptElement.supports("speculationrules") &&
          rental_prefetch_list.length > 0
      ) {
          const specScript = document.createElement("script");
          specScript.type = "speculationrules";
          const specRules = {
              prefetch: [{
                  source: "list",
                  urls: rental_prefetch_list
              }]
          };
          specScript.textContent = JSON.stringify(specRules);
          document.body.append(specScript);
      } else {
          rental_prefetch_list?.forEach(function(x) {
              const linkElem = document.createElement("link");
              linkElem.rel = "prefetch";
              linkElem.href = x;
              document.head.append(linkElem);
          });
      }
  } catch (err) {
      console.warn("Unable to prefetch list items");
  }
}